module.exports = __webpack_public_path__ + "img/logo-inline-white-sm.b1be1112.png";